// Default timezone
export const DEFAULT_TIMEZONE = 'America/Halifax';
